
export const copy = {
  inserted: (el: HTMLElement) => {
    el.style.userSelect = 'all';
    el.style.cursor = 'pointer';
    el.addEventListener('click', (event: MouseEvent) => {
      // Copy the selected text
      document.execCommand('copy');
    });
  },
};

export default copy;
